import React, { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import HomeService from "../../../Services/HomeService";
import { toast } from "react-toastify";
import CityOverview from "../CityOverview/CityOverview";
import ReelsPlayer from "../ReelsPlayer/ReelsPlayer";

import heroImg from "../../../Images/hero-villa.jpg";
import cityImg from "../../../Images/city-skyline.jpg";
import interiorImg from "../../../Images/apartment-interior.jpg";
import towerImg from "../../../Images/property-tower.jpg";

export function WinnersInsightsBlue() {
  const [openItem, setOpenItem] = useState(0); // Set default open index as 0
  const [insights, setInsights] = useState([]);
  const [loading, setLoading] = useState(true);
  const [localityCounts, setLocalityCounts] = useState({});
  const [reelsForCity, setReelsForCity] = useState([]);
  const [cityDetails, setCityDetails] = useState({});
  // const [isReelsPlayerOpen, setIsReelsPlayerOpen] = useState(false);
  // const [selectedReel, setSelectedReel] = useState(null);

  const [playingVideos, setPlayingVideos] = useState({});
  const videoRefs = useRef({});

  const fetchCityDetilsById = async (id) => {
    try {
      const res = await HomeService.getCityDetailsById(id);
      if (res?.status) {
        setCityDetails(res?.data);
      } else {
        console.log(res?.data);
      }
      console.log("CITY DETAILS", res);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchReelsByCityId = async (id) => {
    if (!id) return;
    try {
      const res = await HomeService.getReelsByCityId(id);
      if (res?.status) {
        setReelsForCity(res?.data?.slice(0, 4));
      } else {
        console.log(res?.data);
      }
      console.log("REELS DETAILS", res);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchInsights = async () => {
    setLoading(true);
    try {
      const res = await HomeService?.getPrimeLocationInsights();
      console.log("Prime Location Insights Blue", res);
      if (res?.status) {
        const data = res?.data || [];
        setInsights(data);

        // Fetch locality counts for all insights
        const counts = {};
        for (const insight of data) {
          if (insight.city?._id) {
            try {
              const localityRes = await HomeService?.getLocalityByCityId(
                insight.city._id,
              );
              if (localityRes?.status) {
                counts[insight.city._id] = localityRes?.data?.length || 0;
              }
            } catch (error) {
              console.error(
                `Error fetching localities for city ${insight.city._id}:`,
                error,
              );
              counts[insight.city._id] = 0;
            }
          }
        }
        setLocalityCounts(counts);

        // Fetch reels for the default open item if it exists
        if (data.length > 0 && openItem === 0) {
          const firstCityId = data[0]?.city?._id;
          if (firstCityId) {
            await fetchReelsByCityId(firstCityId);
          }
        }
      } else {
        console.log(res);
        toast.error(res?.message || "Failed to fetch insights");
      }
    } catch (error) {
      console.log(error);
      toast.error("Error fetching insights");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInsights();
    fetchCityDetilsById();
  }, []);

  const toggleItem = async (index, cityId) => {
    if (openItem === index) {
      // If clicking the same item, close it
      setOpenItem(null);
      setReelsForCity([]);
    } else {
      // If clicking a different item, open it and fetch reels
      setOpenItem(index);
      await fetchReelsByCityId(cityId);
    }
  };

  // const handleCloseReelsPlayer = () => {
  //   setIsReelsPlayerOpen(false);
  //   setSelectedReel(null);
  // };

  if (loading) {
    return (
      <section className="ws-insights_blue">
        <div className="ws-insights-inner_blue">
          <div className="ws-insights-head_blue">
            <span className="ws-section-eyebrow_blue">Prime locations & insights</span>
            <h2 className="ws-section-heading_blue">Explore premium real estate markets across India.</h2>
            <p>Discover trending investment zones, city growth analytics and immersive market
              highlights curated for future-ready investors.</p>
          </div>
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="ws-insights_blue">
      <div className="ws-insights-inner_blue">
        <div className="ws-insights-head_blue">
          <span className="ws-section-eyebrow_blue">Prime locations & insights</span>
          <h2 className="ws-section-heading_blue">Explore premium real estate markets across India.</h2>
          <p>Discover trending investment zones, city growth analytics and immersive market
            highlights curated for future-ready investors.</p>
        </div>

        <div className="ws-acc_blue">
          {insights.length === 0 ? (
            <div className="text-center py-5">
              <p style={{ color: "var(--ws-blue-muted-foreground)" }}>No prime location insights available yet.</p>
            </div>
          ) : (
            insights.map((insight, idx) => {
              const isOpen = openItem === idx;
              return (
                <div className="ws-acc-item_blue" key={insight._id || idx} data-open={isOpen}>
                  <button className="ws-acc-trigger_blue" onClick={() => toggleItem(idx, insight?.city?._id)}>
                    <div className="ws-acc-left_blue">
                      <div className="ws-acc-badge_blue">
                        {insight?.city?.name?.charAt(0) || "C"}
                      </div>
                      <div className="ws-acc-title_blue">
                        <h3>{insight?.city?.name || "Unknown City"}</h3>
                        <span>Explore Data</span>
                      </div>
                    </div>
                    <div className="ws-acc-icon_blue"><ChevronDown size={18} /></div>
                  </button>
                  {isOpen && (
                    <div className="ws-acc-body_blue">
                      <CityOverview insight={insight} />
                      {/* <div className="ws-acc-reels_blue">
                        {reelsForCity?.length > 0 ? (
                          reelsForCity.map((reel, k) => (
                            <div
                              className="ws-acc-reel_blue"
                              key={reel._id || k}
                              style={{
                                backgroundImage: `url(${reel.thumbnail})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center"
                              }}
                              onClick={() => {
                                setIsReelsPlayerOpen(true);
                                setSelectedReel(reel);
                              }}
                            />
                          ))
                        ) : ( */}
                     <div className="ws-acc-reels_blue">
  {reelsForCity?.length > 0 ? (
    reelsForCity.map((reel, k) => (
      <div
        className="ws-acc-reel_blue"
        key={reel._id || k}
      >
        {playingVideos[reel._id] ? (
          <video
            src={reel?.video}
            className="reel-video-blue"
            controls
            autoPlay
            playsInline
            preload="metadata"
            onPause={() =>
              setPlayingVideos((prev) => ({
                ...prev,
                [reel._id]: false,
              }))
            }
            onEnded={() =>
              setPlayingVideos((prev) => ({
                ...prev,
                [reel._id]: false,
              }))
            }
          />
        ) : (
          <>
            <img
              src={reel?.thumbnail}
              alt=""
              className="reel-thumb-blue"
            />

            <div className="reel-overlay-blue" />

            <button
              type="button"
              className="reel-play-btn-blue"
              onClick={(e) => {
                e.stopPropagation();

                setPlayingVideos((prev) => ({
                  ...prev,
                  [reel._id]: true,
                }));
              }}
            >
              ▶
            </button>

            <div className="reel-title-blue">
              {reel?.title || "Project Reel"}
            </div>
          </>
        )}
      </div>
    ))
  ) : (
    <div
      className="col-12 text-center py-4"
      style={{ gridColumn: "span 4" }}
    >
      <p
        style={{
          color:
            "var(--ws-blue-muted-foreground)",
        }}
      >
        No reels available for this city yet.
      </p>
    </div>
  )}
</div>
                    </div>
                  )}
                </div>
              );
            })
          )}
        </div>
      </div>
      {/* {isReelsPlayerOpen && selectedReel && (
        <div className="reels-modal-overlay" onClick={handleCloseReelsPlayer}>
          <div
            className="reels-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="close-reels-btn"
              onClick={handleCloseReelsPlayer}
            >
              <i className="fas fa-times"></i>
            </button>
            <ReelsPlayer
              videoUrl={selectedReel?.video}
              autoPlay={true}
              muted={false}
              controls={true}
              loop={true}
            />
          </div>
        </div>
      )} */}
      <style jsx>{`
        .reels-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          padding: 20px;
        }

        .reels-modal-content {
          position: relative;
          max-width: 400px;
          width: 100%;
          height: 90%;
          background: #000;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 10px 50px rgba(0, 0, 0, 0.5);
        }

        .close-reels-btn {
          position: absolute;
          top: 15px;
          right: 15px;
          background: rgba(0, 0, 0, 0.7);
          border: none;
          color: white;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          cursor: pointer;
          z-index: 10;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          transition: all 0.3s ease;
        }

        .close-reels-btn:hover {
          background: rgba(255, 255, 255, 0.2);
          transform: scale(1.1);
        }

        .play-button-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.4);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.3s ease;
          border-radius: 12px;
        }

        .projects_div_wrapper156:hover .play-button-overlay {
          opacity: 1;
        }

        .play-icon {
          width: 60px;
          height: 60px;
          background: rgba(255, 255, 255, 0.9);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #000;
          font-size: 20px;
          transition: transform 0.3s ease;
        }

        .projects_div_wrapper156:hover .play-icon {
          transform: scale(1.1);
        }

        /* Responsive Design for Modal */
        @media (max-width: 768px) {
          .reels-modal-content {
            max-width: 350px;
          }
        }

        @media (max-width: 480px) {
          .reels-modal-content {
            max-width: 300px;
          }

          .reels-modal-overlay {
            padding: 10px;
          }
        }

        /* Ensure the project items are properly styled */
        .projects_div_wrapper156 {
          position: relative;
          transition: transform 0.3s ease;
        }

        .projects_div_wrapper156:hover {
          transform: scale(1.05);
        }

      
      `}</style>
    </section>
  );
}